import styled from 'styled-components'
import { ColorsEnum, ColorsToneEnum } from 'types/cssTypes'

export const ClaimDetailsLogicalGroup = styled.div`
  height: 100%;
  position: relative;
  background: ${({ theme }) => theme.colors.neutral.lightest};
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
  font-family: Milliard;
  ${({ theme }) => theme.typography.m.normal};
  color: ${({ theme }) => theme.colors.primary.dark};
  border: ${({ theme }) => theme.borders.s.solid(ColorsEnum.grey, ColorsToneEnum.lighter)};
`

export const ClaimDetailsLogicalGroupHeader = styled.div`
  height: 3.6rem;
  padding: ${({ theme }) => theme.spacing.xxs} 3px ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.s};
  color: ${({ theme }) => theme.colors.grey.neutral};
  background: ${({ theme }) => theme.colors.neutral.lightest};
  border-bottom: ${({ theme }) => theme.borders.s.solid(ColorsEnum.grey, ColorsToneEnum.lighter)};
  ${({ theme }) => theme.typography.m.medium};
  font-size: 16px;
  border-radius: 10px 10px 0px 0px;
`

export const ClaimDetailDimishedLabelDiv = styled.div`
  font-family: 'Milliard';
  font-style: normal;
  ${({ theme }) => theme.typography.xs.medium};
  color: ${({ theme }) => theme.colors.grey.neutral};
`
